import React from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { FaBookMedical, FaClinicMedical, FaFileInvoice, FaLaptopMedical } from 'react-icons/fa';

const opciones = [
  { id: 'creareclamo', label: 'Crear Reclamo', icon: FaLaptopMedical },
  { id: 'consultareclamogm', label: 'Mis gestiones', icon: FaBookMedical },
  { id: 'consultareclamoindi', cardId: 'consultareclamogmindi', label: 'Consultar gestión', icon: FaFileInvoice },
  { id: 'creaautorizacion', label: 'Crear Autorización', icon: FaClinicMedical }
];

const GestionOptions = ({ selected, onSelect }) => (
  <div className="gestion-options" aria-label="Opciones de gestión">
    <Row>
      {opciones.map(({ id, cardId, label, icon: Icon }) => {
        const isSelected = selected === id;
        return (
          <Col xs="12" sm="6" lg="3" key={id}>
            <Card
              id={cardId || id}
              role="button"
              tabIndex="0"
              aria-pressed={isSelected}
              className={`gestion-option${isSelected ? ' gestion-option--selected' : ''}`}
              onClick={() => onSelect(id)}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onSelect(id);
                }
              }}
            >
              <CardHeader><strong>{label}</strong></CardHeader>
              <CardBody>
                <Icon size="5em" title={label} />
                {isSelected && <span className="gestion-option__status">Seleccionado</span>}
              </CardBody>
            </Card>
          </Col>
        );
      })}
    </Row>
  </div>
);

export default GestionOptions;
